// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__JVvpD","title":"Products_title__1mtYw","item":"Products_item__EvSuf","label":"Products_label__2jo1z","value":"Products_value__odQkp"};